import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  borderColor?: string;
}

export const ThemeCard: React.FC<CardProps & { className?: string }> = ({ children, className, variant, borderColor }) => {
  return (
    <CardStyle className={className} $variant={variant ?? 'primary'} $borderColor={borderColor}>
      {children}
    </CardStyle>
  );
};

const CardStyle = styled.div<{ $variant?: 'primary' | 'secondary'; $borderColor?: string }>`
  background: ${props => (props.$variant === 'primary' ? theme.colors.basic['000'] : '#F7F7FC')};
  transition: all 0.2s ease;
  border: 1px solid ${props => props.$borderColor ?? theme.colors.card.backgroundStroke};
  padding: ${theme.spacing.l};
  border-radius: 18px;
  box-shadow: 4px 4px 10px 0px rgba(20, 20, 43, 0.06);
  box-sizing: border-box;
`;
